import { FeeInfo } from "../view-models/feeInfo";

export class FeeLookupHelper {

  static  getReceiveCurrency(feeInfo: FeeInfo): string {
        if (feeInfo.ReceiveAmounts?.ValidCurrencyIndicator) {
            return feeInfo.ValidReceiveCurrency ?? '';
        } else {
            return feeInfo.EstimatedReceiveCurrency ?? (feeInfo.ValidReceiveCurrency ?? '');
        }
    }

    static  getReceiveAmount(feeInfo: FeeInfo): number {
        if (feeInfo.ReceiveAmounts?.ValidCurrencyIndicator) {
            return feeInfo.ValidReceiveAmount ?? 0;
        } else {
            return feeInfo.EstimatedReceiveAmount ?? 0 > 0 ? feeInfo.EstimatedReceiveAmount ?? 0 : feeInfo.ValidReceiveAmount ?? 0;
        }
    }

    static  getExchangeRate(feeInfo: FeeInfo): number {
        if (feeInfo.ReceiveAmounts?.ValidCurrencyIndicator) {
            return feeInfo.ValidExchangeRate ?? 0;
        } else {
            return feeInfo.EstimatedExchangeRate ?? 0 > 0 ? feeInfo.EstimatedExchangeRate ?? 0 : feeInfo.ValidExchangeRate ?? 0;
        }
    }
}